import { createElement } from 'src/app/core/helpers/dom';

export function createLoadingRowElement(): HTMLElement {
  const classList = ['table__row table__row--loading'];
  const tableSpinner = document.createElement('pp-spinner-standalone');

  const spinnerElement = createElement('div', {
    attrs: {
      class: 'table__spinner',
    },
    children: [tableSpinner],
  });

  const emptyElement = createElement('div', {
    attrs: {
      class: classList,
    },
    children: [spinnerElement],
  });

  return emptyElement;
}
